export default __webpack_public_path__ + "static/media/shape-mitten.547c2149.PNG";